module.exports = __webpack_public_path__ + "static/water-5eb7d6d2dc1cf2c86370fb6dd3b40930.mp4";